import type { ReactNode } from 'react';
import { esEmpresaDemo } from '../empresa-demo';
import { VolverConElPlanCompleto } from './volver-con-el-plan-completo';

/**
 * Mini Prixia (decisión 7): una pantalla que comparte llave con lo que la demo
 * incluye, pero que es del plan completo («Modelos»). En una empresa demo muestra
 * «Esto es parte del plan completo» (X1: vuelve al inicio de la prueba con el cuadro
 * abierto); en cualquier otra, la pantalla de siempre.
 */
export function FueraDeLaDemo({ children }: { children: ReactNode }) {
  if (!esEmpresaDemo()) return <>{children}</>;
  return <VolverConElPlanCompleto />;
}
